import clsx from 'clsx';
import { Phone as PhoneIcon } from 'lucide-react';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { cn } from '@/utils/helper';
import v1 from './phone-v1.module.css';
import v2 from './phone-v2.module.css';

export default function Phone() {
  const { phone, info, openingTimes } = useAppSelector(ConfigSlice.selectors.header);

  if (!phone) return null;

  return (
    <div
      className={clsx(cn(v1.Phone, v2.Phone), {
        [cn(v1.PhoneAlone, v2.PhoneAlone)]: !!(info || openingTimes),
      })}
    >
      <a className={cn(v1.Link, v2.Link)} href={`tel:${phone.replace(/[^0-9]/g, '')}`}>
        <PhoneIcon className={cn(v1.Icon, v2.Icon)} />
        <span className={cn(v1.Number, v2.Number)}>{phone}</span>
      </a>
    </div>
  );
}
